import { promisify } from "util"
import { copyFile } from "fs"
import { fileMakeDirname } from "./fileMakeDirname.js"

const copyFilePromisified = promisify(copyFile)

export const fileCopy = async (source, destination) => {
  await fileMakeDirname(destination)
  return copyFilePromisified(source, destination)
}
